import { useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import SignatureCanvas from 'react-signature-canvas';
import { setSignaturePop, attachSignature } from '../store/api/Services';
import { CheckLg, EraserFill, X } from 'react-bootstrap-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileSignature, faTimes } from '@fortawesome/free-solid-svg-icons';
const Signature = () => {
    const dispatch = useDispatch();
    const popStaus = useSelector(state => state.service.signaturePopStaus);
    const clear = () => sigCanvas.current.clear();
    const save = () => {
        const imageUrl = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
        const onSave = () => {
            if (popStaus.onSave) {
                popStaus.onSave();
            }
            dispatch(setSignaturePop({ show: false }));
        }
        if (!imageUrl) {
            return;
        }
        // const onGetSignature = (sig) => {
        //     const file = new File([sig], "Signature_" + popStaus.parentType + popStaus.parentID + ".png", { type: "image/png" });
        //     attachSignature(popStaus.parentID, popStaus.parentType, file, onSave);
        // }
        // let xhr = new XMLHttpRequest();
        // xhr.open('GET', imageUrl, true);
        // xhr.responseType = 'blob';
        // xhr.onload = e => onGetSignature(xhr.response);
        // xhr.send();
        fetch(imageUrl)
            .then(res => res.blob())
            .then(blob => {
                const file = new File([blob], "Signature_" + popStaus.parentType + popStaus.parentID + ".png", { type: "image/png" });
                attachSignature(popStaus.parentID, popStaus.parentType, file, onSave);
            })


    }
    const sigCanvas = useRef({});
    useEffect(() => {
        const canvas = document.querySelector(".signatureCanvas");
        var ratio = Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext("2d").scale(ratio, ratio);
    }, []);
    const close = () => {
        dispatch(setSignaturePop({ show: false }));
        if (popStaus.onClose) {
            popStaus.onClose();
        }
    }
    return (
        <Modal size="lg" show={true} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>
                <span>
                    <FontAwesomeIcon icon={faFileSignature} size='lg'/>&nbsp;
                دریافت امضا
                </span>
                <FontAwesomeIcon icon={faTimes} size='lg' onClick={close} />
            </Modal.Header>
            <Modal.Body className='bodyStyle'>
                {/* <div style={{ marginBottom: "5px" }} ref={sigParent}> */}
                <SignatureCanvas
                    ref={sigCanvas}
                    canvasProps={{ className: 'signatureCanvas', }}

                />
                <Button className="group-Btn" variant='info' onClick={save}><CheckLg size={16}/> ثبت امضا</Button>
                <Button  className="group-Btn" variant='danger' onClick={clear}><EraserFill size={16}/> پاک کردن صفحه</Button>
                {/* </div> */}
            </Modal.Body>
        </Modal>
    );
}
export default Signature;